import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import PropTypes from "prop-types";
import { createTemplate, updateTemplate } from "actions/notificationTemplates/actions";

class CreateModal extends Component {
    constructor(props) {
        super(props);

        this.handleSave = this.handleSave.bind(this);

        const template = props.templates.find(item => item.id === props.id);

        this.state = {
            name: "",
            messageAM: "",
            messageEN: "",
            messageRU: "",
            titleAM: "",
            titleEN: "",
            titleRU: "",
            ...template
        };

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });
    }

    handleSave = () => {
        if (this.validator.allValid()) {
            const data = Object.assign({}, this.state);
            if (this.props.id) {
                data.id = this.props.id;
                this.props.updateTemplate(data.id, data, this.props.onCancel);
            } else {
                this.props.createTemplate(data, this.props.onCancel);
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    handleInput = (ev) => {
        this.setState({
            [ev.target.name]: ev.target.value
        });
    };

    render() {
        const {
            name,
            messageAM,
            messageEN,
            messageRU,
            titleAM,
            titleEN,
            titleRU
        } = this.state;

        return (
            <div>
                <div className="form-group">
                    <input
                        placeholder="Template Name...."
                        type="text"
                        className="form-control"
                        value={name}
                        name="name"
                        onChange={this.handleInput}
                    />
                    {this.validator.message("name", name, "required")}
                </div>

                <div className="row">
                    <div className="col-12 col-md-4">
                        <div className="card">
                            <div className="p-3 card-body">
                                <h5 className="card-title">Armenian</h5>
                                <div className="form-group">
                                    <input
                                        placeholder="Title"
                                        className="form-control"
                                        type="text"
                                        value={titleAM}
                                        name="titleAM"
                                        onChange={this.handleInput}
                                    />
                                    {this.validator.message("titleAM", titleAM, "required")}
                                </div>
                                <div className="form-group m-0">
                                    <textarea
                                        placeholder="Message"
                                        rows={6}
                                        className="form-control"
                                        value={messageAM}
                                        name="messageAM"
                                        onChange={this.handleInput}
                                    />
                                    {this.validator.message("messageAM", messageAM, "required")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="card">
                            <div className="p-3 card-body">
                                <h5 className="card-title">Russian</h5>
                                <div className="form-group">
                                    <input
                                        placeholder="Title"
                                        className="form-control"
                                        type="text"
                                        value={titleRU}
                                        name="titleRU"
                                        onChange={this.handleInput}
                                    />
                                    {this.validator.message("titleRU", titleRU, "required")}
                                </div>
                                <div className="form-group m-0">
                                    <textarea
                                        placeholder="Message"
                                        rows={6}
                                        className="form-control"
                                        value={messageRU}
                                        name="messageRU"
                                        onChange={this.handleInput}
                                    />
                                    {this.validator.message("messageRU", messageRU, "required")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="card">
                            <div className="p-3 card-body">
                                <h5 className="card-title">English</h5>
                                <div className="form-group">
                                    <input
                                        placeholder="Title"
                                        className="form-control"
                                        type="text"
                                        value={titleEN}
                                        name="titleEN"
                                        onChange={this.handleInput}
                                    />
                                    {this.validator.message("titleEN", titleEN, "required")}
                                </div>
                                <div className="form-group m-0">
                                    <textarea
                                        placeholder="Message"
                                        rows={6}
                                        className="form-control"
                                        value={messageEN}
                                        name="messageEN"
                                        onChange={this.handleInput}
                                    />
                                    {this.validator.message("messageEN", messageEN, "required")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-between">
                    <button
                        className="btn btn-danger"
                        onClick={this.props.onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-success"
                        onClick={this.handleSave}
                    >
                        Save
                    </button>
                </div>
            </div>
        );
    }
}

CreateModal.propTypes = {
    id: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired
};

const mapStateToProps = state => ({
    templates: state.notificationTemplates.list
});

const mapStateToDispatch = dispatch => ({
    createTemplate: bindActionCreators(createTemplate, dispatch),
    updateTemplate: bindActionCreators(updateTemplate, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(CreateModal);



// WEBPACK FOOTER //
// ./src/views/pages/notificationTemplates/create-modal.js